var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-tree',{ref:"tree1",attrs:{"showCheckbox":"","treeData":_vm.options,"draggable":false},on:{"on-drop":_vm.dropNode,"on-checked-item":_vm.checkedItem,"on-selected-change":_vm.clickNode,"on-checked-change":_vm.clickCheckbox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }